





























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IPageParams, IDepartment, IAgreement } from '../../models';
import { getUserFullName } from '@/helpers/functions';
const ns = { namespace: 'agreement' };
import paginationMixin from '@/mixins/pagintation';
@Component({
  methods: {
    getUserFullName,
  },
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'agreement',
  }),
  mixins: [paginationMixin],
})
export default class AgreementList extends Vue {
  @Action('getEntities', ns) getEntities: () => void;
  @Getter('entitiesSlice', ns)
  entitiesSlice: IAgreement[];
  @State('pageParams', ns) pageParams: IPageParams;
  selected = [];
  interval = null;
  headers = [
    { text: 'Название', value: 'name' },
    { text: 'Статус', value: 'agreement_status.name' },
    { text: 'Автор', value: 'creator' },
    { text: 'Контрагент', value: 'contractor.name' },
    { text: 'Ответственный', value: 'responsible' },
  ];
  created() {
    this.getEntities();
  }
}
